<template>
<v-container style="margin: 0px; padding: 0px; max-width:100%">
    <v-toolbar color="indigo" dark dense>
      <v-toolbar-title>{{args.desc}}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items>
          <v-btn dark  text @click.native="close">Close</v-btn>
      </v-toolbar-items>
    </v-toolbar>
    <div class="compact-form"  style="margin-left: 20px;">
      <v-layout row align-center  justify="center">
      <v-radio-group v-model="mode" row>
        <v-radio label="Add New" value="new"></v-radio>
        <v-radio label="Edit Existing" value="existing"></v-radio>
      </v-radio-group>
   
      <v-autocomplete  
        clearable
        style="margin: 0px; padding-top: 25px; padding-right: 20px;" 
        dense 
        v-if="mode == 'existing'" 
        outlined 
        v-model='selectedAction' 
        :items="actions"
        label="Select Action / Bot Pair"
        item-text="actionName"
        item-value="_id"
      >
      <template slot="selection" slot-scope="data">
        Action: {{ data.item.actionName }} - Bot: {{data.item.botName}}
      </template>
      <template slot="item" slot-scope="data">
        Action: {{ data.item.actionName }} - Bot: {{data.item.botName}}
      </template>
      </v-autocomplete>
      
      <v-spacer />
      <v-flex xs1 >
        <v-btn color='blue' :disabled="!routingData.module || !routingData.action || !routingData.bot" @click="save">Save</v-btn>
      </v-flex>
      </v-layout>
      <div id="routingDefinition">
        <v-layout row>
          <v-flex xs12>
            <h3>Route Definition:</h3>
          </v-flex>
        <v-spacer></v-spacer>
          <v-flex xs3>
            <v-autocomplete dense v-model="routingData.module" label="Module" outlined :items="modules" item-text="name" item-value="_id"></v-autocomplete>
          </v-flex>
          <v-flex xs1/>
          <v-flex xs3>
            <v-autocomplete dense v-model="routingData.action" label="Action" outlined :items="actionchoices" item-text="name" item-value="_id"></v-autocomplete>
          </v-flex>
          <v-flex xs1/>
          <v-flex xs3>
            <v-autocomplete dense v-model="routingData.bot" label="Target Bot" outlined :items="botchoices" item-text="name" item-value="_id"></v-autocomplete>
          </v-flex>
        </v-layout>
        <v-layout row>
           <v-flex xs12>
            <h3>Default Route Behavior:</h3>
            <v-switch v-model="routingData.delTemp" label="Delete Temp Workflow Request" color="success"  hide-details></v-switch>
            <v-switch v-model="routingData.active" label="Active Route" color="success" hide-details></v-switch>
          </v-flex>
          <v-spacer></v-spacer>
        </v-layout>
        <v-layout row>
          <v-flex xs12>
            <h3><br>Translation Instructions from Worfklow Request to Bot Command</h3><br>
          </v-flex>
          <v-flex xs12>
            <v-spacer></v-spacer>
             <server-table-component
              :rowProp="cmdRows"
              :schema="cmdSchema"
              :table="cmdSchema"
              embed
              v-on:updateTable="handleUpdateTable"
            ></server-table-component>
          </v-flex>
        </v-layout>
      </div>
    </div>
  </v-container>
</template>
<script>
import { sync } from "vuex-pathify"
import axiosInstances from "@/../../coreui/server/axiosInstances"
export default {
  props: ['args'],
  data: () => ({
    mode: 'new',
    actions: [],
    modules: [],
    routingData: {},
    botchoices: [],
    actionchoices: [],
    existingActionSearch: null,
    cmdRows: [],
    cmdSchema: "sch_auth_workflow_cmd_cart",
    selectedAction: null
  }),
  watch: {
    mode: {
      async handler (val) {
        this.clear()
        if (val == 'new') {
        } else {
          let curActions = await axiosInstances.loginServer.get('/dt/v1/auth_workflow_routing')
          let dataSet = curActions.data
          for(let i = 0; i < dataSet.length; i++){
            let currentAction = this.actionchoices.find(x => x["_id"] === dataSet[i].action)
            let botName = this.botchoices.find(x => x["_id"] === dataSet[i].next)
            dataSet[i].actionName = currentAction.name
            dataSet[i].botName = botName.name
          }
          this.actions = dataSet.sort((a,b) => (a.actionName.toLowerCase() > b.actionName.toLowerCase()) ? 1 : -1)
        }
      }
    },
    cmdDialog(val) {
      val || this.close()
    },
    selectedAction(val) {
        console.log('Action Selected: ', val)
        let actionRecord = this.actions.find(x => x["_id"] === val)
        console.log('Action Record: ', actionRecord)
        if(actionRecord === undefined){
          this.clear()
          return
        }
        this.routingData.id = actionRecord["_id"]
        this.routingData.module = actionRecord["module"]
        this.routingData.action = actionRecord["action"]
        this.routingData.bot = actionRecord["next"]
        this.routingData.delTemp = (actionRecord["deltemp"] === "yes") ? true : false
        this.routingData.active = (actionRecord["IsUsed"] === "yes") ? true : false
        this.cmdRows = actionRecord["cmd"]
    },
    
  },
  methods: {
    handleUpdateTable(val) {
      console.log("Got a table update")
      this.cmdRows.length = 0
      this.cmdRows = val
      console.log(val)
    },
    actionName(val) {
      let choice = this.actionchoices.find(x => x["_id"] === val)
      console.los(choice)
      return choice.name
    },
    cmdEditItem(item) {
      this.cmdEditIndex = this.cmdItems.indexOf(item)
      this.cmdEditedItem = Object.assign({}, item)
      this.cmdDialog = true
    },
    cmdDeleteItem(item){
      this.cmdEditIndex = this.cmdItems.indexOf(item)
      this.cmdEditedItem = Object.assign({}, item)
      this.cmdDeleteDialog = true
    },
    cmdDeleteConfirm(){
      this.cmdItems.splice(this.cmdEditIndex,1)
      this.cmdCloseDelete()
    },
    cmdClose(){
      this.cmdDialog = false
      this.$nextTick(() => {
        this.cmdEditedItem = Object.assign({}, this.cmdDefaultItem)
        this.cmdEditIndex = -1
      })
    },
    cmdCloseDelete(){
      this.cmdDeleteDialog = false
      this.$nextTick(() => {
        this.cmdEditedItem = Object.assign({}, this.cmdDefaultItem)
        this.cmdEditIndex = -1
      })
    },
    cmdSave(){
      if (this.cmdEditIndex > -1){
        Object.assign(this.cmdItems[this.cmdEditIndex], this.cmdEditedItem)
      } else {
        this.cmdItems.push(this.cmdEditedItem) 
      }
    },
    close() {
      this.$router.go(-1)
    },
    async save () {
      console.log(`In the save function`)
      let payload = {}
      payload.IsUsed = this.routingData.active ? "yes" : "no"
      payload.deltemp = this.routingData.delTemp ? "yes" : "no"
      payload.next = this.routingData.bot
      payload.cmd = this.cmdRows
      payload.module = this.routingData.module
      payload.action = this.routingData.action
      if(this.routingData.hasOwnProperty("id")){
        console.log('This is an update')
        payload["_id"] = this.routingData.id
        axiosInstances.loginServer.get('/dt/v1/auth_workflow_routing')
        await axiosInstances.loginServer.patch('/dt/v1/auth_workflow_routing/'+this.routingData.id, payload)
      } else {
        console.log('This is a new entry')
        await axiosInstances.loginServer.post('/dt/v1/auth_workflow_routing', payload)
      }
      this.mode = "new"
      this.clear()
    },
    clear() {
      this.routingData = {}
      this.cmdRows = []
      this.selectedAction = null
    },
  },
  async mounted () {
    let modules = await axiosInstances.loginServer.get('/dt/v1/sup_modules')
    let botChoices = await axiosInstances.loginServer.get('/dt/v1/auth_bot')
    let botActions = await axiosInstances.loginServer.get('/dt/v1/auth_bot_actions')
    let schema = await axiosInstances.loginServer.get('/dt/v1/sch_auth_workflow_cmd_cart')

    console.log(schema)
    let sortedModules = modules.data.sort((a,b) => (a.name.toLowerCase() > b.name.toLowerCase()) ? 1 : -1)
    let sortedBots = botChoices.data.sort((a,b) => (a.name.toLowerCase() > b.name.toLowerCase()) ? 1 : -1)
    let sortedActions = botActions.data.sort((a,b) => (a.name.toLowerCase() > b.name.toLowerCase()) ? 1 : -1)
    this.modules = sortedModules
    this.botchoices = sortedBots
    this.actionchoices = sortedActions
  }
}
</script>
<style scoped>
.compact-form {
    transform: scale(0.95);
    transform-origin: left;
}
</style>